import { useMemo } from "react";
import type { KPIThresholdConfig } from "@/pages/configuration/models/ShiftReportConfig";
import { INCENTIVE_KPI_NAME } from "@/pages/configuration/models/ShiftReportConfig";
import { useSearchShiftReportConfig } from "@/pages/configuration/pages/shift-report-config/ShiftReportConfigPage";

interface UseIncThresholdsResult {
	thresholds: KPIThresholdConfig;
	isLoading: boolean;
}

const INCENTIVE_DEFAULTS: KPIThresholdConfig = {
	Name: "Incentive",
	MaxValue: 100,
	Red: 0,
	Orange: 20,
	Yellow: 40,
	GreenSoft: 60,
	GreenNormal: 80,
	GreenHard: 100,
};

/**
 * Returns 6-zone incentive thresholds from the shift report configuration.
 *
 * While the config query is loading (or if no Incentive row exists),
 * returns hardcoded defaults that match the seed values.
 */
export const useIncThresholds = (): UseIncThresholdsResult => {
	const { data, isLoading } = useSearchShiftReportConfig();

	const thresholds = useMemo(() => {
		if (!data) return INCENTIVE_DEFAULTS;
		const row = data.Thresholds.find((t) => t.Name === INCENTIVE_KPI_NAME);
		return row ?? INCENTIVE_DEFAULTS;
	}, [data]);

	return { thresholds, isLoading };
};
